import { render } from "./PopupImage.vue?vue&type=template&id=1ab184c0&scoped=true"
import script from "./PopupImage.vue?vue&type=script&scoped=true&lang=js"
export * from "./PopupImage.vue?vue&type=script&scoped=true&lang=js"

import "./PopupImage.vue?vue&type=style&index=0&id=1ab184c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab184c0"]])

export default __exports__